import * as React from 'react'
import { withRouter } from 'next/router'
import { getActorTracks, getAllTrackToActors } from '../../../../../models/Actor'
import { getCanonicalSlug, getTrackBySlugAsync } from '../../../../../models/Track'
import type { TrackPropsType } from '../../../../../models/Track'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { PageTitle } from '@components/shared/PageTitle'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared'
import { Loading } from '@components/shared/Loading'
import { Suspense } from 'react'

function GetTracksList (props: {actorId: string}): React.ReactNode {
  const [tracks, setTracks] = React.useState<TrackPropsType[]>([])
  React.useEffect((): void => {
    getActorTracks(props.actorId).then((tracks: TrackPropsType[]): void => {
      setTracks(tracks)
    })
  }, [props.actorId])
  if (tracks.length === 0) {
    return <Loading height={'100px'}/>
  }
  return <>{tracks.map((track: TrackPropsType): React.ReactNode => (
    <SectionDivider key={track.id}>
      <TrackListItemComponent {...track}/>
    </SectionDivider>
  ))}</>
}

function Actor (props: {characterName?: string, slug: string, actorId: string}): React.ReactNode {
  let character = 'More with this Narrator'
  if (props.characterName) {
    character = `More with the Narrator who voices ${props.characterName}`
  }
  return (
    <DiscoverLayout
      title={`${character} on Dispea`}
      description={`Listen to ${character} on Dipsea`}
      canonicalUrl={`https://www.dipseastories.com/chapters/${props.slug}/more-like-actor/${props.actorId}`}
    >
      <PageTitle title={character}/>
      <Suspense>
        <GetTracksList actorId={props.actorId}/>
      </Suspense>

    </DiscoverLayout>
  )
}
export default withRouter(Actor as any) as any

type ContextType = {
  params: {
    slug: string,
    actorId: string
  }
}
export async function getStaticProps (
  context: ContextType
): Promise<{ props: { characterName?: string, actorId: string }}> {
  const track = await getTrackBySlugAsync(context.params.slug)
  const trackSlug = getCanonicalSlug(track)
  const actorTrack = track?.actors?.[context.params.actorId]
  const characterName = actorTrack?.characterName

  return { props: { characterName, ...({ slug: trackSlug } as any), actorId: context.params.actorId } }
}

type SlugsStaticType = { paths: { params: { slug: string, actorId: string } }[], fallback: boolean }
export function getStaticSlugsPaths (slugs: string[][]): SlugsStaticType {
  return {
    paths: slugs.map((slug: string[]): {params: {slug: string, actorId: string}} => ({ params: { slug: slug[0], actorId: slug[1] } })),
    fallback: false
  }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs: string[][] = await getAllTrackToActors()
  return getStaticSlugsPaths(slugs)
}

const SectionDivider = styled.div<any>`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): any => config(props).media.md`
    padding: 30px 0;
  `}
`
